/* ==========================================
   BUNDLE CART ENHANCER
========================================== */
const comfortBundleContents = {

    Essentials: 'Neck Rest + Back Rest',

    Plus: 'Neck Rest + Back Rest + Armrest + Seatbelt Cover',

    Ultimate: 'Neck Rest + Back Rest + Armrest + Seatbelt Cover + Steering Cover'

};
document.addEventListener('DOMContentLoaded', () => {

    console.log('Bundle Cart Enhancer Ready ✅');

    bundleCartEnhancer();

    document.addEventListener('cart-update', bundleCartEnhancer);

});


function bundleCartEnhancer() {

    console.log('Running Bundle Cart Enhancer...');

    const cartItems = document.querySelectorAll('.previewCartItem');

    cartItems.forEach((item, index) => {
const title = item.querySelector('.previewCartItem-name .text')?.textContent.trim();

const variant = item.querySelector('.previewCartItem-variant')?.textContent.trim();

const bundleType = variant?.split('/')[0].trim();

const includes = comfortBundleContents[bundleType];

const colour = variant?.split('/')[1].trim();

console.log('Title:', title);
console.log('Bundle:', bundleType);
console.log('Colour:', colour);
console.log('Includes:', includes);
const options = item.querySelector('.previewCartItem-options');
item.querySelector('.cw-includes')?.remove();

const div = document.createElement('div');
div.className = 'cw-includes';

div.textContent = 'Includes: ' + includes;
div.style.fontSize = '13px';
div.style.lineHeight = '1.4';
div.style.color = '#555';
div.style.marginTop = '6px';
options.appendChild(div);
    });
}